import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

import { statusLabel } from './apiKeysTableHelpers';
import classes from './styles/status-chip.module.scss';
import { ApiKeyStatus } from './types';

interface StatusChipProps {
  status: ApiKeyStatus;
}

export const StatusChip: FunctionComponent<StatusChipProps> = ({ status }) => (
  <span
    className={classnames(classes.chip, {
      [classes.active]: status === 'active',
      [classes.expiring]: status === 'expiring',
      [classes.disabled]: status === 'disabled',
    })}
  >
    {statusLabel(status)}
  </span>
);
